export default crypto;
export var isCryptoKey = function isCryptoKey(key) {
  return key instanceof CryptoKey;
};